import Property3RightGridContainer from "../../../components/property/grid/Property2RightGrid";

const Property3RightGrid = () => {
  return <Property3RightGridContainer />;
};

export default Property3RightGrid;
